export default __webpack_public_path__ + "static/media/meeting-room.398b25df.svg";